module.exports = __webpack_public_path__ + "img/tip_2.88b7a61d.png";